module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects-wrapper",
    style: ({
      height: _vm.windowHeight + 'px'
    })
  }, [_c('div', {
    staticClass: "project-frame",
    style: ({
      height: _vm.windowHeight + 'px',
      width: _vm.windowWidth + 'px',
      left: _vm.sidebarWidth + 'px',
      top: _vm.windowMargin + 'px'
    })
  }, [(_vm.layout.type == 'small' || _vm.layout.type == 'medium') ? _c('div', {
    directives: [{
      name: "touch",
      rawName: "v-touch:tap",
      value: (_vm.handleDetectorClick),
      expression: "handleDetectorClick",
      arg: "tap"
    }, {
      name: "touch",
      rawName: "v-touch:swipeleft",
      value: (_vm.handleSwipe),
      expression: "handleSwipe",
      arg: "swipeleft"
    }, {
      name: "touch",
      rawName: "v-touch:swiperight",
      value: (_vm.handleSwipe),
      expression: "handleSwipe",
      arg: "swiperight"
    }, {
      name: "touch",
      rawName: "v-touch:swipeup",
      value: (_vm.handleSwipe),
      expression: "handleSwipe",
      arg: "swipeup"
    }, {
      name: "touch",
      rawName: "v-touch:swipedown",
      value: (_vm.handleSwipe),
      expression: "handleSwipe",
      arg: "swipedown"
    }],
    staticClass: "projects-swipe-area text-center",
    style: ({
      height: _vm.layout.galleryHeight + 'px',
      width: _vm.windowWidth + 'px',
      left: _vm.layout.offsetLeft + 'px',
      top: _vm.layout.offsetTop + 'px'
    }),
    on: {
      "click": _vm.handleDetectorClick,
      "scroll": _vm.handleDetector,
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        return _vm.preventArrowKeys($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        return _vm.preventArrowKeys($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "left", 37, $event.key, ["Left", "ArrowLeft"])) { return null; }
        if ('button' in $event && $event.button !== 0) { return null; }
        return _vm.preventArrowKeys($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "right", 39, $event.key, ["Right", "ArrowRight"])) { return null; }
        if ('button' in $event && $event.button !== 2) { return null; }
        return _vm.preventArrowKeys($event)
      }]
    }
  }) : _vm._e(), _vm._v(" "), (_vm.layout.type == 'large') ? _c('div', {
    directives: [{
      name: "touch",
      rawName: "v-touch:swipeleft",
      value: (_vm.handleSwipe),
      expression: "handleSwipe",
      arg: "swipeleft"
    }, {
      name: "touch",
      rawName: "v-touch:swiperight",
      value: (_vm.handleSwipe),
      expression: "handleSwipe",
      arg: "swiperight"
    }, {
      name: "touch",
      rawName: "v-touch:swipeup",
      value: (_vm.handleSwipe),
      expression: "handleSwipe",
      arg: "swipeup"
    }, {
      name: "touch",
      rawName: "v-touch:swipedown",
      value: (_vm.handleSwipe),
      expression: "handleSwipe",
      arg: "swipedown"
    }],
    staticClass: "projects-detector",
    style: ({
      height: _vm.layout.galleryHeight + 'px',
      width: _vm.viewportWidth + 'px',
      left: _vm.layout.offsetLeft + 'px'
    }),
    attrs: {
      "id": "swipe-detector"
    },
    on: {
      "mousemove": _vm.handleMouseMove,
      "click": _vm.handleDetectorClick,
      "scroll": _vm.handleDetector,
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        return _vm.preventArrowKeys($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        return _vm.preventArrowKeys($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "left", 37, $event.key, ["Left", "ArrowLeft"])) { return null; }
        if ('button' in $event && $event.button !== 0) { return null; }
        return _vm.preventArrowKeys($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "right", 39, $event.key, ["Right", "ArrowRight"])) { return null; }
        if ('button' in $event && $event.button !== 2) { return null; }
        return _vm.preventArrowKeys($event)
      }]
    }
  }, [_c('div', {
    staticClass: "detector-content",
    style: ({
      height: 4000 + 'px',
      width: 4000 + 'px'
    })
  }, [_vm._v("\n                 \n            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "component-projects",
    style: ({
      height: _vm.windowHeight + 'px'
    })
  }, [(_vm.projectsVisible) ? _c('div', {
    staticClass: "projects-vertical-track"
  }, _vm._l((_vm.filteredProjects), function(project, index) {
    return _c('project-component', {
      attrs: {
        "project": project,
        "index": index
      },
      on: {
        "projectEnd": _vm.projectEnd
      }
    })
  }), 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-47e27735!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/projects.vue
// module id = 186
// module chunks = 2